import { MenuItem } from "./menu.types";

export const menuItems4: MenuItem[] = [
  {
    id: 41,
    label: "Expert profile",
    icon: "las la-user-tie",
    to: "/expert-profile",
    permissionId: 15,
  },
  {
    id: 7,
    label: "Chats",
    icon: "lab la-rocketchat",
    to: "/chats",
    permissionId: 7,
  },
];
